export default __webpack_public_path__ + "static/media/BG-Red-0004.5466f706.png";